
// function to fetch the modal content and render it
async function renderSTLModal(urlHandle) {
  await fetch(`${window.Shopify.routes.root}pages/shop-the-look/${urlHandle}`)
  .then(response => response.text())
  .then(html => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const stlSection = doc.querySelector('.shop-the-look-section');
    const main = document.querySelector('main-content');
    const template = `
      <shop-the-look-modal id="modal-${urlHandle}">
        <div class="stl-modal-wrapper">
          ${stlSection.innerHTML}
        </div>
      </shop-the-look-modal>
    `

    main.insertAdjacentHTML('beforeend', template);
  });
}

window.addEventListener('DOMContentLoaded', () => {
  // Get all modals to fetch from the page
  let modalsToFetch = [...document.querySelectorAll('a[data-stl-modal]')].map(link => link.dataset.stlModal);
  // If there are no modals to fetch, return
  if (!modalsToFetch.length) return
  // Remove duplicates
  modalsToFetch = [...new Set(modalsToFetch)];
  // create an array of promises for each modal to fetch
  const promises = modalsToFetch.map(modal => renderSTLModal(modal));
  // fetch all modals
  Promise.all(promises)
    .then(() => {
        console.log('All modals fetched');
    })
    .catch((e) => {
        console.error(e);
    });
  // Add event listeners to open modals
  document.querySelectorAll('a[data-stl-modal]').forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const modal = document.querySelector(`#modal-${link.dataset.stlModal}`);
      if (!modal) return
      modal.openModal();
    });
  });
});


if (!customElements.get('shop-the-look-modal')) {
  customElements.define('shop-the-look-modal', class ShopTheLook extends HTMLElement {
    constructor() {
      super();

      this.closeButton = this.querySelector('.close_modal');
      this.image = this.querySelector('shop-the-look .stl_image');
      this.stlComponent = this.querySelector('shop-the-look');
    }

    connectedCallback() {
      // close with button
      this.closeButton.addEventListener('click', this.closeModal.bind(this));
      // close with click outside
      this.addEventListener('click', (e) => {
        if (e.target === this) this.closeModal();
      });
      // close with escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.classList.contains('active')) this.closeModal();
      });
    }

    setContentHeight() {
      this.stlComponent.style.setProperty('--stl-content-height', this.image.clientHeight + 'px');
    }

    closeModal() {
      this.classList.remove('active');
      document.body.style.overflow = 'auto';
    }

    openModal() {
      if(this.stlComponent) {
        this.setContentHeight();
        this.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    }
  });
}